import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../../lib/api";
import { AuthLayout } from "./LoginPage";

export function RequestPasswordResetPage() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  return (
    <AuthLayout title="Passwort zurücksetzen">
      {done ? (
        <p>Falls ein Account existiert, bekommst du gleich eine E-Mail mit einem Link.</p>
      ) : (
        <form
          className="space-y-4"
          onSubmit={async (e) => {
            e.preventDefault();
            await api("/api/auth/request-password-reset", {
              method: "POST",
              body: JSON.stringify({ email }),
            });
            setDone(true);
          }}
        >
          <label className="label">E-Mail</label>
          <input type="email" required className="input" value={email} onChange={(e) => setEmail(e.target.value)} />
          <button className="btn-primary w-full">Link anfordern</button>
          <div className="text-center text-sm"><Link to="/login" className="underline">Zurück zum Login</Link></div>
        </form>
      )}
    </AuthLayout>
  );
}

export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const [password, setPassword] = useState("");
  const [done, setDone] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  return (
    <AuthLayout title="Neues Passwort setzen">
      {done ? (
        <p>Passwort aktualisiert. <Link to="/login" className="underline">Einloggen</Link></p>
      ) : (
        <form
          className="space-y-4"
          onSubmit={async (e) => {
            e.preventDefault();
            setErr(null);
            try {
              await api("/api/auth/reset-password", {
                method: "POST",
                body: JSON.stringify({ token, password }),
              });
              setDone(true);
            } catch {
              setErr("Link ungültig oder abgelaufen");
            }
          }}
        >
          <label className="label">Neues Passwort (mind. 10 Zeichen)</label>
          <input type="password" required minLength={10} className="input" value={password} onChange={(e) => setPassword(e.target.value)} />
          {err && <p className="text-red-600 text-sm">{err}</p>}
          <button className="btn-primary w-full">Passwort setzen</button>
        </form>
      )}
    </AuthLayout>
  );
}
